import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  }
});

export default function CenteredTabs(props) {
  const classes = useStyles();
  const { currentTab, onChangeTab } = props;
  // console.log(props);

  const handleChange = (event, newValue) => {
    onChangeTab(newValue);
  };

  return (
    <div className="footer">
      <Paper className={classes.root}>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="All" />
          <Tab label="To Do" />
          <Tab label="Doing" />
          <Tab label="Completed" />
        </Tabs>
      </Paper>
    </div>
  );
}
